import React from "react"

const LogoKWW = props => {
  return (
    <svg
      version="1.1"
      id="KWW-SVG"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="184px"
      height="60px"
      viewBox="0 0 184 60"
      enableBackground="new 0 0 184 60"
    >
      <g>
        <path d="M0.182,48.726h1.53v5.396l2.133-5.396h1.545l-2.237,5.396l2.413,5.741H3.845l-2.133-5.741v5.741h-1.53V48.726z" />
        <path d="M6.96,48.726h4.069v1.27H8.491v3.528h2.251v1.27H8.491v3.8h2.539v1.271H6.96V48.726z" />
        <path
          d="M12.872,48.726h1.427l1.523,4.444c0.441,1.255,0.831,2.595,1.17,4.019c-0.123-0.861-0.214-1.641-0.272-2.339
		c-0.059-0.697-0.088-1.353-0.088-1.969v-4.155h1.537v11.138h-1.435L15.02,54.85c-0.157-0.465-0.305-0.944-0.445-1.435
		c-0.14-0.491-0.268-1.005-0.386-1.544c-0.01-0.066-0.025-0.148-0.047-0.245c-0.022-0.097-0.048-0.207-0.077-0.332
		c0.015,0.125,0.026,0.231,0.037,0.32c0.01,0.09,0.017,0.165,0.022,0.229l0.081,1.132l0.081,1.378
		c0.004,0.077,0.008,0.171,0.011,0.28c0.002,0.112,0.004,0.237,0.004,0.376l0.081,4.854h-1.508V48.726z"
        />
        <path
          d="M20.357,48.726h1.427l1.523,4.444c0.441,1.255,0.831,2.595,1.17,4.019c-0.123-0.861-0.213-1.641-0.272-2.339
		c-0.059-0.697-0.088-1.353-0.088-1.969v-4.155h1.537v11.138H24.22l-1.714-5.014c-0.157-0.465-0.305-0.944-0.445-1.435
		c-0.14-0.491-0.268-1.005-0.386-1.544c-0.009-0.066-0.025-0.148-0.047-0.245s-0.048-0.207-0.077-0.332
		c0.015,0.125,0.026,0.231,0.037,0.32c0.01,0.09,0.017,0.165,0.022,0.229l0.081,1.132l0.081,1.378
		c0.004,0.077,0.008,0.171,0.011,0.28c0.002,0.112,0.004,0.237,0.004,0.376l0.081,4.854h-1.508V48.726z"
        />
        <path d="M27.843,48.726h4.068v1.27h-2.538v3.528h2.251v1.27h-2.251v3.8h2.538v1.271h-4.068V48.726z" />
        <path d="M32.849,48.726h4.981v1.313h-1.714v9.824h-1.501v-9.824h-1.766V48.726z" />
        <path d="M39.113,48.726h1.53v4.357h2.244v-4.357h1.53v11.138h-1.53v-5.511h-2.244v5.511h-1.53V48.726z" />
      </g>
      <g>
        <path
          d="M50.528,48.726h1.494l0.78,5.173l0.126,0.765c0.06,0.414,0.104,0.791,0.134,1.132l0.082,0.946
		c0.005,0.023,0.01,0.066,0.015,0.128c0.005,0.063,0.012,0.142,0.022,0.239l0.037-0.361c0.06-0.63,0.123-1.209,0.189-1.738
		c0.067-0.529,0.14-1.017,0.22-1.464l0.824-4.819h1.189l0.773,4.683c0.114,0.692,0.209,1.333,0.286,1.926
		c0.076,0.591,0.14,1.156,0.189,1.695c0.049-0.567,0.105-1.116,0.167-1.646c0.062-0.528,0.128-1.048,0.197-1.559l0.111-0.742
		l0.661-4.357h1.479l-2.028,11.138h-1.204l-0.81-4.812c-0.005-0.019-0.017-0.099-0.037-0.238c-0.02-0.139-0.049-0.339-0.089-0.598
		l-0.156-1.111c-0.01-0.087-0.026-0.217-0.048-0.389c-0.022-0.174-0.046-0.393-0.071-0.657l-0.037-0.461
		c-0.01,0.11-0.02,0.207-0.03,0.289c-0.01,0.081-0.017,0.148-0.022,0.201c-0.025,0.317-0.046,0.562-0.063,0.739
		c-0.018,0.176-0.029,0.282-0.034,0.32l-0.156,1.068c-0.035,0.245-0.062,0.438-0.082,0.577c-0.02,0.139-0.035,0.226-0.044,0.259
		l-0.84,4.812h-1.241L50.528,48.726z"
        />
        <path d="M61.019,48.726h1.545v11.138h-1.545V48.726z" />
        <path d="M64.941,48.726h1.545v9.867h2.526v1.271h-4.071V48.726z" />
        <path d="M70.587,48.726h1.545v9.867h2.526v1.271h-4.071V48.726z" />
        <path d="M76.233,48.726h1.545v11.138h-1.545V48.726z" />
        <path
          d="M81.791,48.726h1.203l2.459,11.138h-1.53l-0.431-2.171h-2.274l-0.438,2.171h-1.486L81.791,48.726z M83.269,56.53
		l-0.342-1.773c-0.228-1.207-0.414-2.497-0.557-3.867c-0.069,0.67-0.159,1.346-0.267,2.031c-0.109,0.685-0.238,1.412-0.386,2.182
		l-0.283,1.428H83.269z"
        />
        <path
          d="M87.511,48.726h1.323l1.01,4.544c0.124,0.569,0.236,1.137,0.338,1.707c0.101,0.569,0.194,1.167,0.278,1.793
		c0.009-0.082,0.017-0.146,0.022-0.192c0.005-0.045,0.01-0.076,0.015-0.097l0.215-1.276l0.194-1.212l0.171-0.801l0.899-4.466h1.337
		l1.055,11.138H92.89l-0.26-3.78c-0.01-0.191-0.019-0.356-0.026-0.497c-0.007-0.14-0.012-0.255-0.012-0.346l-0.066-1.493
		l-0.037-1.372c0-0.008-0.002-0.028-0.004-0.06c-0.002-0.032-0.006-0.073-0.011-0.127l-0.038,0.224
		c-0.039,0.266-0.075,0.495-0.108,0.692c-0.032,0.197-0.061,0.364-0.085,0.497L92.05,54.62l-0.074,0.382l-0.966,4.861H89.97
		l-0.906-4.197c-0.125-0.554-0.235-1.114-0.332-1.686c-0.096-0.569-0.184-1.166-0.264-1.792l-0.445,7.675h-1.456L87.511,48.726z"
        />
      </g>
      <g>
        <path
          d="M101.034,48.726h1.522l0.796,5.173l0.128,0.765c0.061,0.414,0.106,0.791,0.137,1.132l0.083,0.946
		c0.005,0.023,0.01,0.066,0.016,0.128c0.005,0.063,0.013,0.142,0.022,0.239l0.038-0.361c0.061-0.63,0.125-1.209,0.193-1.738
		c0.067-0.529,0.143-1.017,0.223-1.464l0.841-4.819h1.212l0.787,4.683c0.117,0.692,0.214,1.333,0.292,1.926
		c0.079,0.591,0.144,1.156,0.193,1.695c0.051-0.567,0.107-1.116,0.171-1.646c0.062-0.528,0.129-1.048,0.2-1.559l0.113-0.742
		l0.675-4.357h1.508l-2.069,11.138h-1.227l-0.825-4.812c-0.006-0.019-0.018-0.099-0.038-0.238c-0.02-0.139-0.05-0.339-0.091-0.598
		l-0.158-1.111c-0.011-0.087-0.027-0.217-0.05-0.389c-0.023-0.174-0.047-0.393-0.072-0.657l-0.038-0.461
		c-0.01,0.11-0.02,0.207-0.029,0.289c-0.011,0.081-0.019,0.148-0.023,0.201c-0.025,0.317-0.047,0.562-0.064,0.739
		c-0.018,0.176-0.029,0.282-0.034,0.32l-0.158,1.068c-0.036,0.245-0.063,0.438-0.084,0.577c-0.02,0.139-0.035,0.226-0.046,0.259
		l-0.855,4.812h-1.265L101.034,48.726z"
        />
        <path
          d="M113.517,48.726h1.228l2.507,11.138h-1.561l-0.439-2.171h-2.317l-0.446,2.171h-1.516L113.517,48.726z M115.024,56.53
		l-0.349-1.773c-0.232-1.207-0.422-2.497-0.568-3.867c-0.071,0.67-0.162,1.346-0.272,2.031c-0.111,0.685-0.242,1.412-0.395,2.182
		l-0.287,1.428H115.024z"
        />
        <path d="M119.184,48.726h1.576v9.867h2.575v1.271h-4.151V48.726z" />
        <path d="M124.131,48.726h5.128v1.313h-1.765v9.824h-1.546v-9.824h-1.817V48.726z" />
        <path
          d="M137.099,54.569c0,1.966-0.23,3.363-0.689,4.19c-0.46,0.828-1.229,1.24-2.311,1.24c-1.136,0-1.936-0.444-2.4-1.333
		c-0.46-0.871-0.689-2.417-0.689-4.64c0-1.98,0.228-3.383,0.682-4.205c0.459-0.826,1.237-1.24,2.333-1.24
		c0.979,0,1.707,0.32,2.182,0.96c0.312,0.427,0.54,1.036,0.682,1.823C137.027,52.097,137.099,53.165,137.099,54.569z
		 M135.447,54.729c0-1.93-0.091-3.208-0.272-3.839c-0.183-0.634-0.553-0.952-1.113-0.952s-0.935,0.292-1.122,0.874
		c-0.181,0.586-0.271,1.764-0.271,3.534c0,1.629,0.096,2.761,0.288,3.39c0.196,0.596,0.564,0.895,1.105,0.895
		c0.529,0,0.894-0.278,1.091-0.836C135.349,57.24,135.447,56.219,135.447,54.729z"
        />
        <path
          d="M139.668,48.726h1.469l1.568,4.444c0.454,1.255,0.855,2.595,1.204,4.019c-0.126-0.861-0.22-1.641-0.28-2.339
		c-0.061-0.697-0.091-1.353-0.091-1.969v-4.155h1.583v11.138h-1.477l-1.765-5.014c-0.162-0.465-0.314-0.944-0.458-1.435
		c-0.145-0.491-0.277-1.005-0.398-1.544c-0.01-0.066-0.026-0.148-0.049-0.245s-0.05-0.207-0.079-0.332
		c0.015,0.125,0.027,0.231,0.037,0.32c0.01,0.09,0.018,0.165,0.022,0.229l0.083,1.132l0.084,1.378
		c0.005,0.077,0.009,0.171,0.012,0.28c0.002,0.112,0.003,0.237,0.003,0.376l0.084,4.854h-1.553V48.726z"
        />
      </g>
      <g>
        <path
          d="M155.456,59.774h-3.128V48.637h3.03c1.511,0,2.631,0.298,3.361,0.889c0.86,0.697,1.291,1.665,1.291,2.906
		c0,1.353-0.459,2.358-1.374,3.022c-0.625,0.447-1.522,0.671-2.692,0.671h-0.488V59.774z M155.456,53.622l0.143,0.007
		c0.38,0,0.683-0.112,0.908-0.336s0.337-0.529,0.337-0.919c0-0.384-0.109-0.696-0.33-0.938c-0.22-0.245-0.5-0.367-0.84-0.367h-0.218
		V53.622z"
        />
        <path
          d="M173.947,59.774h-3.271l-0.232-5.078l-0.098-2.025c-0.035,0.389-0.075,0.761-0.12,1.113
		c-0.045,0.354-0.1,0.697-0.165,1.027l-0.983,4.963h-2.551l-0.839-4.97c-0.05-0.288-0.118-0.784-0.203-1.485
		c-0.01-0.106-0.032-0.321-0.067-0.648l-0.075,2.054l-0.277,5.05h-3.331l1.351-11.138h3.894l0.652,3.752
		c0.055,0.307,0.104,0.643,0.146,1.003c0.042,0.36,0.081,0.753,0.116,1.175c0.065-0.706,0.155-1.339,0.27-1.896l0.796-4.034h3.863
		L173.947,59.774z"
        />
        <path
          d="M179.386,59.774h-3.128V48.637h3.03c1.511,0,2.631,0.298,3.361,0.889c0.86,0.697,1.291,1.665,1.291,2.906
		c0,1.353-0.458,2.358-1.374,3.022c-0.625,0.447-1.522,0.671-2.692,0.671h-0.488V59.774z M179.386,53.622l0.143,0.007
		c0.38,0,0.683-0.112,0.908-0.336s0.337-0.529,0.337-0.919c0-0.384-0.109-0.696-0.329-0.938c-0.221-0.245-0.501-0.367-0.841-0.367
		h-0.218V53.622z"
        />
      </g>
      <polygon points="145.204,44.191 123.108,22.097 101.012,44.191 101.012,0 145.204,0 " />
      <polygon points="94.699,44.191 72.602,22.097 50.505,44.191 50.505,0 94.699,0 " />
      <polygon points="44.192,0 22.096,22.097 44.192,44.191 0,44.191 0,0 " />
    </svg>
  )
}

export default LogoKWW
